(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initToc(root) {
    var prose = root.querySelector('[data-article-prose]');
    var list = root.querySelector('[data-article-toc-list]');
    if (!prose || !list) return;

    var headings = prose.querySelectorAll('h2');
    if (!headings.length) {
      var nav = root.querySelector('[data-article-toc]');
      if (nav) nav.hidden = true;
      return;
    }

    list.innerHTML = '';
    var tocLinks = [];

    headings.forEach(function (heading, index) {
      if (!heading.id) {
        var base = slugify(heading.textContent || 'section-' + (index + 1));
        var id = base || 'section-' + (index + 1);
        var suffix = 1;
        while (document.getElementById(id)) {
          id = base + '-' + suffix;
          suffix += 1;
        }
        heading.id = id;
      }

      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      li.appendChild(link);
      list.appendChild(li);
      tocLinks.push({ link: link, el: heading });
    });

    function onScroll() {
      var y = window.scrollY + 120;
      var current = tocLinks[0];
      tocLinks.forEach(function (item) {
        if (item.el.offsetTop <= y) current = item;
      });
      tocLinks.forEach(function (item) {
        item.link.classList.remove('is-active');
      });
      if (current) current.link.classList.add('is-active');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFaq(root) {
    root.querySelectorAll('.stl-faq-q').forEach(function (btn) {
      if (btn.dataset.faqInit === 'true') return;
      btn.dataset.faqInit = 'true';

      btn.addEventListener('click', function () {
        var item = btn.closest('.stl-faq-item');
        if (!item) return;
        var answer = item.querySelector('.stl-faq-a');
        if (!answer) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        answer.hidden = open;
        var icon = btn.querySelector('span');
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    root.querySelectorAll('.stl-faq-item').forEach(function (item, index) {
      var btn = item.querySelector('.stl-faq-q');
      var answer = item.querySelector('.stl-faq-a');
      if (!btn || !answer) return;
      if (index > 0 && !btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', 'false');
        answer.hidden = true;
      }
    });
  }

  function initProseTables(root) {
    var prose = root.querySelector('[data-article-prose]');
    if (!prose) return;

    prose.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('table-wrapper')) return;
      var wrap = document.createElement('div');
      wrap.className = 'table-wrapper';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function initInlineBanners(root) {
    var template = root.querySelector('[data-article-inline-banniere-template]');
    var prose = root.querySelector('[data-article-prose]');
    if (!template || !prose || prose.dataset.inlineBannersInit === 'true') return;
    prose.dataset.inlineBannersInit = 'true';

    var points = [];
    var seen = new Set();

    function addPoint(type, node) {
      if (!node) return;
      var key = type === 'append' ? 'append' : 'before:' + node;
      if (seen.has(key)) return;
      seen.add(key);
      points.push({ type: type, node: node });
    }

    var h2s = Array.prototype.filter.call(prose.querySelectorAll('h2'), function (heading) {
      return !heading.closest('.stl-article-faq');
    });

    if (h2s.length >= 2) {
      addPoint('before', h2s[1]);
    }

    if (h2s.length > 0) {
      addPoint('before', h2s[Math.floor(h2s.length / 2)]);
    } else {
      var children = Array.prototype.filter.call(prose.children, function (el) {
        return el.nodeType === 1 && !el.classList.contains('stl-article-faq');
      });
      if (children.length > 0) {
        addPoint('before', children[Math.floor(children.length / 2)]);
      }
    }

    addPoint('append', prose);

    points.sort(function (a, b) {
      if (a.type === 'append' && b.type !== 'append') return 1;
      if (b.type === 'append' && a.type !== 'append') return -1;
      if (a.type === 'append' && b.type === 'append') return 0;
      if (a.node === b.node) return 0;
      var pos = a.node.compareDocumentPosition(b.node);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return 1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return -1;
      return 0;
    });

    points.forEach(function (point) {
      var fragment = template.content.cloneNode(true);
      if (point.type === 'before') {
        point.node.parentNode.insertBefore(fragment, point.node);
      } else {
        point.node.appendChild(fragment);
      }
    });
  }

  function initArticle(root) {
    initInlineBanners(root);
    initToc(root);
    initFaq(root);
    initProseTables(root);
  }

  function boot() {
    document.querySelectorAll('[data-stellar-article]').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
